import { createClient } from '@supabase/supabase-js'
import { Database } from '@/types/supabase'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Helper function to handle Supabase errors
export const handleSupabaseError = (error: any) => {
  console.error('Supabase error:', error)
  
  if (error.code === 'PGRST301') {
    throw new Error('Unauthorized access')
  }
  
  if (error.code === 'PGRST116') {
    throw new Error('Resource not found')
  }
  
  throw new Error(error.message || 'An error occurred with the database')
}

// Helper function to handle subscription data
export const getSubscriptionData = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from('user_subscriptions')
      .select('*')
      .eq('user_id', userId)
      .single()

    if (error) {
      if (error.code === 'PGRST116') {
        return null;
      }
      handleSupabaseError(error)
    }

    return data
  } catch (error) {
    console.error('Error fetching subscription data:', error)
    throw error
  }
}

// Helper function to update subscription data
export const updateSubscriptionData = async (
  userId: string,
  subscriptionData: Partial<Database['public']['Tables']['user_subscriptions']['Update']>
) => {
  try {
    const { data, error } = await supabase
      .from('user_subscriptions')
      .update(subscriptionData)
      .eq('user_id', userId)
      .select()
      .single()

    if (error) {
      handleSupabaseError(error)
    }

    return data
  } catch (error) {
    console.error('Error updating subscription data:', error)
    throw error
  }
} 